<nova-rich-tooltip [isVisible]="isUnableToValidate()" [displayTemplate]="tooltipTemplate">
    @if (isUnableToValidate())
    {
        <div><mat-icon class="mat-icon">report</mat-icon></div>
    }
    <div [class.display-text]="isUnableToValidate()">
        <span [class]="isMatchedClass()">
            {{displayText()}}
        </span>
    </div>
</nova-rich-tooltip>

<ng-template #tooltipTemplate>
    <span>The system cannot validate this requirement. <br>Please review the candidate's profile to ensure <br>they have the required experience.</span>
</ng-template>
